import { render, staticRenderFns } from "./UcAddressCard.yaml?vue&type=template&id=2e548b51&component"
import script from "./UcAddressCard.yaml?vue&type=script&lang=ts&component"
export * from "./UcAddressCard.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports